import DividerWithText from '../../../../../components/DividerWithText';
import PhotoPickerSummary from '../../../../../components/PhotoPicker/PhotoPickerSummary';
import { useTranslation } from 'react-i18next';
import RowResumeText from '../../../../../components/RowResumeText';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import WorkShiftsItem from '../../../Company/Employees/AccessRightsSection/Components/WorkShiftsItem';
import CustomizedItem from '../../../Company/Employees/AccessRightsSection/Components/CustomizedItem';
import NotInformation from '../../../../../components/NotInformation';
import SummaryContainer from '../../Components/SummaryContainer';
import SummaryFieldsUser from '../../Components/SummaryFieldsUser';
import SummaryOtherDetailsCard from '../../../Company/Employees/EnrollmentSteps/SubComponents/SummaryOtherDetailsCard';
import SummaryAccessRightsCard from '../../../Company/Employees/EnrollmentSteps/SubComponents/SummaryAccessRightsCard';
import SummaryDetailsCard from './SummaryDetailsCard';
import { UseCameraIcon } from '../../../../../components/buttons/IconButtons';

/**
 * @Author: Susana García Rodriguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */

const Summary = ({
    user,
    workShiftsList,
    customizedList,
    photoPicker,
    getAllServiceType,
    extraDataEnabled,
    headersList,
    extraData,
}) => {
    const { t } = useTranslation();

    const item = getAllServiceType.find((item) => item.id === user?.serviceTypeId);
    return (
        <>
            <div className='row mt-4'>
                <div className={'row mb-4 px-0'}>
                    <div className={`background-general-00 border-radius-8px border-full-shades-300 p-0`}>
                        <div className={'p-3 d-flex align-items-center'}>
                            <div className={'mr-2'}>
                                <UseCameraIcon width={24} height={24} />
                            </div>
                            <p className={'font-color-general-950 ibl-font-w-600 fs-14-to-13 '}>{t('photography')}</p>
                        </div>
                        <div className={'border-bottom-shades-300 w-100'} />
                        <div className={'p-3'}>
                            <PhotoPickerSummary photoPicker={photoPicker} classWith={'w-400px'} />
                        </div>
                    </div>
                </div>

                <div className={'row mb-4 px-0'}>
                    <SummaryDetailsCard user={user} item={item} />
                </div>

                <div className={'row mb-4 px-0'}>
                    <SummaryFieldsUser user={user} />
                </div>

                {extraDataEnabled && (
                    <div className={'row mb-4 px-0'}>
                        <SummaryOtherDetailsCard extraData={extraData} headersList={headersList} />
                    </div>
                )}
                <div className={'row mb-4 px-0'}>
                    <SummaryAccessRightsCard workShiftsList={workShiftsList} customizedList={customizedList} />
                </div>
            </div>
        </>
    );
};

export default Summary;
